import React, { useState } from 'react'
import GetTfidbUserReports from '../../Services/Queries/GetTfidbUserReports'
import 'bootstrap/dist/css/bootstrap.min.css'
import BarGraph from './ChatBar'
import './UserReportDashboard.css' // Custom CSS for styling

const UserReportDashboard = () => {
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [view, setView] = useState('Day')
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleInputChange = setState => e => setState(e.target.value)

  const handleViewChange = e => {
    setView(e.target.value)
  }

  const getReportData = async () => {
    try {
      setLoading(true)
      setError(null)

      const input = {
        fromDate: parseInt(fromDate.replace(/-/g, ''), 10),
        toDate: parseInt(toDate.replace(/-/g, ''), 10),
        view,
      }

      const responseData = await GetTfidbUserReports(input)
      setData(responseData.userReportInfo)
    } catch (error) {
      setError('Error fetching user reports')
      console.error('Error fetching user reports:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleFetchData = () => {
    if (!fromDate || !toDate) {
      setError('Please select both From Date and To Date.')
      return
    }

    getReportData()
  }

  const handleReset = () => {
    setFromDate('')
    setToDate('')
    setView('Day')
    setData([])
    setError(null)
  }

  const isDisabled = (!fromDate && !toDate) || loading
  return (
    <div className='container mt-5'>
      <h1 className='mb-4'>User Report Dashboard</h1>
      {error && <div className='alert alert-danger'>{error}</div>}
      <div className='row mb-3 align-items-end'>
        <div className='col-md-3'>
          <label className='form-label'>From Date</label>
          <input
            type='date'
            className='form-control'
            value={fromDate}
            onChange={handleInputChange(setFromDate)}
            placeholder='From Date'
            title='Select a start date'
          />
        </div>
        <div className='col-md-3'>
          <label className='form-label'>To Date</label>
          <input
            type='date'
            className='form-control'
            value={toDate}
            onChange={handleInputChange(setToDate)}
            placeholder='To Date'
            title='Select an end date'
          />
        </div>
      </div>
      <div className='d-flex gap-2 mr-4'>
        <div className='form-check mr-4'>
          <input
            type='radio'
            id='dayView'
            name='view'
            value='Day'
            checked={view === 'Day'}
            onChange={handleViewChange}
            className='form-check-input'
          />
          <label htmlFor='dayView' className='form-check-label'>
            Day
          </label>
        </div>
        <div className='form-check mr-4'>
          <input
            type='radio'
            id='monthView'
            name='view'
            value='Month'
            checked={view === 'Month'}
            onChange={handleViewChange}
            className='form-check-input'
          />
          <label htmlFor='monthView' className='form-check-label'>
            Month
          </label>
        </div>
        <div className='col-md-4 d-flex justify-content-end'>
          <button
            className={`btn btn-primary me-2 ${isDisabled ? 'disabled' : ''}`}
            onClick={handleFetchData}
            disabled={isDisabled}
          >
            {loading ? 'Fetching...' : 'Fetch Data'}
          </button>
          <button
            className='btn btn-primary
          '
            onClick={handleReset}
            disabled={loading}
          >
            Reset
          </button>
        </div>
      </div>
      {data && data.length >= 1 && (
        <div>
          <BarGraph data={data} />
        </div>
      )}
    </div>
  )
}

export default UserReportDashboard
